import React from "react";

const TERMS_OF_SERVICE_URL = "https://www.oppizi.com/terms-of-service";

export type TermsAgreementNoteProps = {
  /**
   * The label of the button this note sits under. Interpolated verbatim so the
   * note can never claim a button the UI doesn't show — the channels label it
   * differently ("Go to payment" vs "Submit and Pay", and just "Submit" when
   * payment is skipped).
   */
  actionLabel: string;
  className?: string;
  /** Optional per-channel Copilot anchor, e.g. ADM passes "admTermsAcceptNote". */
  dataCy?: string;
};

/**
 * Inline terms acknowledgement shown under the submit button, replacing the
 * blocking "tick to agree" modal that used to appear after clicking it.
 */
export const TermsAgreementNote = ({ actionLabel, className = "", dataCy }: TermsAgreementNoteProps) => (
  <p
    className={`text-muted-foreground m-0 text-xs leading-4 ${className}`}
    data-cypress-id="termsAgreementNote"
    data-cy={dataCy}
  >
    By clicking {actionLabel} you agree to the{" "}
    <a
      href={TERMS_OF_SERVICE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="underline hover:text-foreground"
      data-cypress-id="termsAgreementNoteLink"
    >
      Terms of Service
    </a>
    .
  </p>
);

export default TermsAgreementNote;
